// EditQueryModal.jsx
import React, { useState } from 'react';
import { updateDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import './EditQueryModal.css';

const EditQueryModal = ({ query, onClose, onSave }) => {
  const [title, setTitle] = useState(query?.title || '');
  const [description, setDescription] = useState(query?.description || '');
  const [filters, setFilters] = useState(query?.filters || []);
  const [location, setLocation] = useState(query?.location || query?.geoTag || '');
  const [error, setError] = useState('');

  const allFilters = ["general", "social", "environmental", "technological", "studies", "others"];

  const handleFilterChange = (filter) => {
    setFilters(prev => prev.includes(filter) ? prev.filter(f => f !== filter) : [...prev, filter]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const queryRef = doc(db, "queries", query.id);
      await updateDoc(queryRef, {
        title,
        description,
        filters,
        location,
        geoTag: location
      });
      if (onSave) onSave(query.id);
      onClose();
    } catch (err) {
      setError('Error updating query.');
      console.error(err);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>Edit Query</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Title:</label>
            <input 
              type="text" 
              value={title} 
              onChange={(e) => setTitle(e.target.value)} 
              required 
            />
          </div>
          <div className="input-group">
            <label>Description:</label>
            <textarea 
              value={description} 
              onChange={(e) => setDescription(e.target.value)} 
              rows="4" 
              required 
            />
          </div>
          <div className="input-group">
            <label>Location:</label>
            <input 
              type="text" 
              value={location} 
              onChange={(e) => setLocation(e.target.value)} 
              placeholder="e.g., Hyderabad, New York, Delhi"
            />
          </div>
          <div className="input-group">
            <label>Filters:</label>
            <div className="filters-group">
              {allFilters.map(filter => (
                <label key={filter}>
                  <input
                    type="checkbox"
                    checked={filters.includes(filter)}
                    onChange={() => handleFilterChange(filter)}
                  />
                  {filter}
                </label>
              ))}
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="close-button">Cancel</button>
            <button type="submit" className="submit-button">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditQueryModal;
